import React from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import OurStory from '../components/OurStory';
import Partners from '../components/Partners';
import DonationCTA from '../components/DonationCTA';
import SectionDivider from '../components/SectionDivider';

/** Home doubles as the About page: who we are, why, and who we work with. */
const HomePage: React.FC = () => {
  return (
    <div>
      <Hero />
      <SectionDivider />
      <Mission />
      <SectionDivider />
      <OurStory />
      <SectionDivider />
      <Partners />
      <SectionDivider />
      <DonationCTA />
    </div>
  );
};

export default HomePage;
